import { render, staticRenderFns } from "./puracquisition.vue?vue&type=template&id=4a2c04f5&scoped=true&"
import script from "./puracquisition.vue?vue&type=script&lang=js&"
export * from "./puracquisition.vue?vue&type=script&lang=js&"
import style0 from "./puracquisition.vue?vue&type=style&index=0&id=4a2c04f5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2c04f5",
  null
  
)

export default component.exports